export interface IFormItem {
    sectionName: string,
    style: string,
    fields: string[],
    subSection?: {
        name: string,
        fields: string[]
    }
}

export interface IFormItemRow {
    sections: IFormItem[]
}